import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { setData } from '../../features/mainSlice';
import { color } from '../../app/theme';
import TextField from '../shared/TextField';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    block: {
      display: 'flex',
      alignItems: 'center',
    },
    option: {
      marginRight: 36,
    },
    radioInput: {
      fontSize: 15,
    },
    radio: {
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$13,
      display: 'flex',
      alignItems: 'center',
    },
    input: {
      width: 80,
      margin: '0 8px',
    },
  },
  {
    name: 'TripNum',
  },
);

const TripNum = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [radioType, setRadioType] = useState('off');
  const { limits } = useSelector(state => state.ma?.data);
  const { isActive } = useSelector(store => store.ma);
  const { per_customer: tripNum } = limits || {};

  const onChange = value => {
    if (value === 'on') {
      dispatch(
        setData({
          limits: {
            ...limits,
            per_customer: 1,
          },
        }),
      );
    } else if (value === 'onceByDay') {
      dispatch(
        setData({
          limits: {
            ...limits,
            per_customer: 'onceByDay',
          },
        }),
      );
    } else {
      dispatch(
        setData({
          limits: {
            ...limits,
            per_customer: undefined,
          },
        }),
      );
    }
  };

  const setNum = event => {
    const { value = 1 } = event.target;
    if (value > 0) {
      dispatch(
        setData({
          limits: {
            ...limits,
            per_customer: parseInt(value || 1, 10),
          },
        }),
      );
    }
  };

  useEffect(() => {
    if (tripNum === 'onceByDay') {
      setRadioType(tripNum);
    } else {
      setRadioType(tripNum === undefined ? 'off' : 'on');
    }
  }, [tripNum]);

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('setting.tripNum')}</div>
      <FormControl component="fieldset">
        <RadioGroup
          row
          aria-label="default-display"
          name="default-display"
          value={radioType}
          onChange={e => onChange(e?.target?.value)}
        >
          <FormControlLabel
            className={classes.option}
            classes={{
              label: classes.radioInput,
            }}
            value="on"
            control={<Radio color="primary" disabled={isActive} />}
            label={
              <div className={classes.radio}>
                {t('setting.tripNum-on')}
                <TextField
                  className={classes.input}
                  type="text"
                  isValid
                  placeholder="1"
                  value={tripNum === 'onceByDay' ? 0 : tripNum || 0}
                  onChange={setNum}
                  disabled={
                    tripNum === undefined || tripNum === 'onceByDay' || isActive
                  }
                />
                {t('setting.tripNum-on-2')}
              </div>
            }
          />
          <FormControlLabel
            className={classes.option}
            classes={{
              label: classes.radioInput,
            }}
            value="onceByDay"
            control={<Radio color="primary" disabled={isActive} />}
            label={
              <div className={classes.radio}>
                {t('setting.tripNum-onceByDay')}
              </div>
            }
          />
          <FormControlLabel
            className={classes.option}
            classes={{
              label: classes.radioInput,
            }}
            value="off"
            control={<Radio color="primary" disabled={isActive} />}
            label={
              <div className={classes.radio}>{t('setting.tripNum-off')}</div>
            }
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default TripNum;
